// Web Push helpers: register SW, subscribe/unsubscribe, status
import { api } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

function arrayBufferToBase64(buf) {
  const bytes = new Uint8Array(buf);
  let bin = '';
  for (let i = 0; i < bytes.byteLength; i++) bin += String.fromCharCode(bytes[i]);
  return window.btoa(bin);
}

export function isPushSupported() {
  return typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window;
}

let swRegistrationPromise = null;
export async function getSwRegistration() {
  if (!isPushSupported()) return null;
  if (swRegistrationPromise) return swRegistrationPromise;
  swRegistrationPromise = navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
  return swRegistrationPromise;
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error('Push API nu este suportat in acest browser.');
  if (Notification.permission === 'denied') throw new Error('Notificarile sunt blocate. Activeaza-le din setarile browser-ului.');
  if (Notification.permission === 'default') {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') throw new Error('Ai refuzat permisiunea pentru notificari.');
  }
  await getSwRegistration();
  const reg = await navigator.serviceWorker.ready;
  // Get VAPID public key
  const { data } = await api.get('/push/vapid-public-key');
  const pub = data.publicKey;
  // Subscribe with push manager
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(pub),
  });
  // Send to backend
  await api.post('/push/subscribe', {
    endpoint: sub.endpoint,
    keys: {
      p256dh: arrayBufferToBase64(sub.getKey('p256dh')),
      auth: arrayBufferToBase64(sub.getKey('auth')),
    },
  });
  return sub;
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.ready.catch(() => null);
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await api.post('/push/unsubscribe', { endpoint: sub.endpoint });
  } catch (e) { /* ignore */ }
  await sub.unsubscribe();
}

export async function sendTestPush() {
  return api.post('/push/test', {});
}
